<template>
   <div>
     <button>
       <!-- <router-link :to="{ name: 'owner-terminal-transactions', query: {branchName: data.branchName, paymentDate: data.paymentDate}}" class="btn dealers_btn ">
            Details
       </router-link> -->
       <div class="btn dealers_btn mr-3" @click="showDetails()">
        {{$t('text.clickButtons.details')}}
        </div>
</button>
   </div>
</template>

<script>
import configObject from "@/config";
import Jquery from "jquery";
let $ = Jquery;

export default {
  data() {
    return {
      data: {},
    };
  },
  mounted() {
      
  },
  methods: {
    showDetails() {
        this.$eventHub.$emit("_showDetails", this.data);
    }
  },
};
</script>